<div class="container">
    <div class="row">
        <ng-content select=".top"></ng-content>
    </div>

    <div class="row">
        <ng-content select=".bottom"></ng-content>
    </div>
</div>